import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateMonthComponent } from './date.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DateMonthComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule
    
  ], exports:[
    DateMonthComponent
  ]
})
export class DateMonthInputModule { }
